<script>
import Label from "./Label.vue";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "ckeditor5-build-classic-with-font";

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true,
    },
  },
  components: {
    Label,
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      value: this.item_value,
      editor: ClassicEditor,
      d_check: this.selectedItem
        ? typeof this.selectedItem[this.item.displayOn] != "string"
          ? JSON.stringify(this.selectedItem[this.item.displayOn]) ==
            this.item.displayOnValue
          : this.selectedItem[this.item.displayOn] == this.item.displayOnValue
        : false,
      d_check2: this.selectedItem
        ? typeof this.selectedItem[this.item.displayOn2] != "string"
          ? JSON.stringify(this.selectedItem[this.item.displayOn2]) ==
            this.item.displayOnValue2
          : this.selectedItem[this.item.displayOn2] == this.item.displayOnValue2
        : false,
      disable_check:
        this.selectedItem &&
        this.item.disableOn &&
        this.selectedItem[this.item.disableOn]
          ? false
          : true,
    };
  },
  computed: {
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
    display_none_check2: {
      get: function () {
        return this.d_check2;
      },
      set: function (newValue) {
        this.d_check2 = newValue;
      },
    },
    editorConfig() {
      return (
        this.item.editorConfig || {
          toolbar: [
            "heading",
            "|",
            "fontColor",
            "|",
            "bold",
            "link",
            "bulletedList",
            "numberedList",
            "blockQuote",
            "insertTable",
            "undo",
            "redo",
          ],
          heading: {
            options: [
              {
                model: "paragraph",
                title: "Paragraph",
                class: "ck-heading_paragraph",
              },
              {
                model: "heading1",
                view: "h1",
                title: "Heading 1",
                class: "ck-heading_heading1",
              },
              {
                model: "heading2",
                view: "h2",
                title: "Heading 2",
                class: "ck-heading_heading2",
              },
              {
                model: "heading3",
                view: "h3",
                title: "Heading 3",
                class: "ck-heading_heading3",
              },
              {
                model: "heading4",
                view: "h4",
                title: "Heading 4",
                class: "ck-heading_heading4",
              },
            ],
          },
          table: {
            contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
          },
          fontColor: {
            colors: [
              {
                color: "#005EB8",
                label: "Blue",
              },
              {
                color: "#FF2E2E",
                label: "Red",
              },
              {
                color: "#4F535B",
                label: "Main Grey",
              },
            ],
          },
          link: {
            decorators: {
              toggleDownloadable: {
                mode: "manual",
                label: "Downloadable",
                attributes: {
                  download: "file",
                },
              },
              openInNewTab: {
                mode: "manual",
                label: "Open in a new tab",
                attributes: {
                  target: "_blank",
                  rel: "noopener noreferrer",
                },
              },
            },
          },
        }
      );
    },
  },
  watch: {
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          if (typeof val.value != "string") {
            this.display_none_check =
              JSON.stringify(val.value) == this.item.displayOnValue
                ? true
                : false;
          } else {
            this.display_none_check =
              val.value == this.item.displayOnValue ? true : false;
          }
        }
        if (val && this.item.displayOn2 && val.key == this.item.displayOn2) {
          if (typeof val.value != "string") {
            this.display_none_check2 =
              JSON.stringify(val.value) == this.item.displayOnValue2
                ? true
                : false;
          } else {
            this.display_none_check2 =
              val.value == this.item.displayOnValue2 ? true : false;
          }
        }
        if (val && this.item.displayOn3 && val.key == this.item.displayOn3) {
          if (typeof val.value != "string") {
            this.display_none_check3 =
              JSON.stringify(val.value) == this.item.displayOnValue3
                ? true
                : false;
          } else {
            this.display_none_check3 =
              val.value == this.item.displayOnValue3 ? true : false;
          }
        }
        if (val && this.item.disableOn && val.key == this.item.disableOn) {
          console.log(val.value);
          let d_check = !val.value;
          // let d_check = val.value.find(x => JSON.stringify(x) == this.item.disableOnValue)
          this.disable_check = d_check ? true : false;
        }
      },
      deep: true,
    },
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
    d_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
    display_none_check2(val) {
      this.item.display = this.item.displayOn2 && !val ? false : true;
    },
  },
  mounted() {
    this.item.display = false;
  },
};
</script>
<template>
  <div
    class="mb-3"
    :class="{
      'd-none':
        (item.displayOn && !display_none_check) ||
        (item.displayOn2 && !display_none_check2),
    }"
  >
    <Label :item="item" :model_length="validation.$model.length" />
    <ckeditor
      :class="{ [item_key]: item_key }"
      v-model="value"
      :editor="editor"
      :config="editorConfig"
      :readonly="
        this.$route.params.categoryName == 'globalupdate'
          ? false
          : selectedItem?.additionalProp1 && selectedItem.additionalProp1.global
          ? true
          : false
      "
      :disabled="
        item.disabled
          ? true
          : this.$route.params.categoryName == 'globalupdate'
          ? false
          : selectedItem?.additionalProp1 && selectedItem.additionalProp1.global
          ? true
          : false
      "
    ></ckeditor>
    <div v-if="submitted && validation.$error" class="invalid-feedback">
      <span v-if="!validation.required">This value is required.</span>
    </div>
  </div>
</template>
<style scoped>
.ck.ck-editor {
  border: 1px solid #ced4da;
  border-radius: 4px;
}
</style>
